import { render, staticRenderFns } from "./InspirationListItem.vue?vue&type=template&id=244db24a"
import script from "./InspirationListItem.vue?vue&type=script&lang=js"
export * from "./InspirationListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports